// combatpro/panels/monsters/studio/MonsterStudioSpellPicker.js
//
// Combat PRO - MonsterStudioSpellPicker (Stage 56: Editor Runtime Foundation).
//
// The spellcasting tab picker, ported from the legacy viStudioSpellHtml /
// viStudioAddSpell / viStudioRemoveSpell (battletracker.html 11149-11169). A
// datalist-backed search input over the existing spell database, an add button,
// an explanatory note, and the assigned-spell chips with per-chip remove. The
// search field's text is local UI state (the only state here); committing a spell
// and removing one are delegated to the editor runtime (onAdd / onRemove).
//
// The spell name source is the runtime spell database window.VI_SPELLS_DB - the
// same global the rest of Combat PRO reads (legacy SPELLS_DB) - read defensively;
// no cloud, no fetch, no persistence. The legacy "custom spell creation arrives in
// a later phase" note text is preserved verbatim, as is the placeholder.
//
// No DOM manipulation, no querySelector. No optional chaining. No em dash.

import React, { useState } from 'react';

function MonsterStudioSpellPicker(props) {
  var spells = Array.isArray(props.spells) ? props.spells : [];
  const [input, setInput] = useState('');

  var db = (typeof window !== 'undefined' && Array.isArray(window.VI_SPELLS_DB)) ? window.VI_SPELLS_DB : [];
  var names = db.map(function(sp) { return sp && sp.name; }).filter(Boolean);

  function add() {
    var v = input.trim();
    if (!v) { return; }
    props.onAdd(v);
    setInput('');
  }

  return (
    <>
      <div className="vi-st-spell-add">
        <input
          list="vi-st-spell-list"
          id="vi-st-spell-input"
          type="text"
          placeholder={'Search the 319-spell database\u2026'}
          value={input}
          onChange={function(e) { setInput(e.target.value); }}
        />
        <datalist id="vi-st-spell-list">
          {names.map(function(n, i) { return <option key={i} value={n} />; })}
        </datalist>
        <button className="vi-st-add" type="button" onClick={add}>{'\u2795'} Add Spell</button>
      </div>
      <div className="vi-st-spell-note">Custom spell creation arrives in a later phase. Select from the existing database for now.</div>
      <div className="vi-st-spell-chips">
        {spells.map(function(n, i) {
          return (
            <span className="vi-st-chip" key={i}>
              {'\u2728'} {n}
              <button type="button" onClick={function() { props.onRemove(i); }}>{'\u00d7'}</button>
            </span>
          );
        })}
      </div>
    </>
  );
}

export default MonsterStudioSpellPicker;
